<script setup>

import { useUserStore } from '@/model/dataLayer/api/userStore'

const userStore = useUserStore()
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="height: calc(100vh - 72px);"
  >
    <v-card
      class="pa-6 d-flex flex-column justify-center align-center text-center"
      elevation="0"
      width="100%"
    >
      <template>
        <div class="text-caption mt-4">
          请输入6位代码，
          我们刚刚将其发送到{{ userStore.emailInput.value }}。
          请注意，此有效期为60分钟。
        </div>
        <v-otp-input
          v-model="userStore.otpInput.value"
          :error="userStore.otpError.value"
          :loading="userStore.loading.value"
          autofocus
          @finish="userStore.acceptInviteByCode()"
        />
        <v-btn
          class="primary"
          rounded
          width="50%"
          @click="userStore.acceptReset()"
        >
          Zurück
        </v-btn>
      </template>
    </v-card>
  </div>
</template>

<style scoped>

</style>
